<template>
    <div class="modal is-active">
        <div class="modal-background" />
        <div class="modal-card">
            <header class="modal-card-head" />
            <section class="modal-card-body">
                <div v-for="session in sessions" :key="session._id">
                    <user-school-session-resume v-bind="session" />
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success">Save changes</button>
            </footer>
        </div>
        <router-link
            :to="`/project/${$store.getters.project._id}`"
            class="modal-close is-large"
            aria-label="close"
        />
    </div>
</template>

<script>
import { fetchItems } from '@/services/API';
import UserSchoolSessionResume from '@/components/UserSchoolSessionResume';
export default {
    components: {
        UserSchoolSessionResume,
    },
    data() {
        return {
            sessions: [],
        };
    },
    async mounted() {
        console.log('mounted sessions');
        let sessions = await fetchItems('session', {
            project: this.$store.getters.project._id,
        });
        this.sessions = sessions.data;
    },
};
</script>

<style></style>
